import { useFormatPrice } from "hooks";
import React from "react";

const TableProdWidget = ({ imgUrl, item }) => {
  const formatPrice = useFormatPrice();
  return (
    <div className="flex w-max max-w-[450px] items-center gap-[10px]">
      <img
        src={imgUrl}
        alt="product_img"
        className="img-fluid w-[35px] bg-white !rounded-[5px] shadow-md"
      />
      <div className="mr-[20px] grid ml-[10px] leading-5">
        <span className="text-[14px] ">{item.label}</span>
        <span className="text-[12px] text-gray-500">
          {item.sku} | {formatPrice(item.unitPrice)}
        </span>
      </div>
    </div>
  );
};

export default TableProdWidget;
